import React from "react";
import "./GrantAccessRequest.less";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SearchRequest from "./SearchRequest";
import ToastMessage from "../../common/toastMsg";
import BrrRequest from "./BrrRequest";
import FullPageLoader from "../../../views/loader/fullPage-loader";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import BiometricRequest from "./BiometricRequest";
export default class GrantAccessRequest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textRequestedId: null,
      visitorData: [],
      isAPICalled: false,
      isBRRCompleted: false,
      enableBRR: false,
      uploadDoc: false,
      isSignedDocument: false,
      showSuccessIcon: false,
      biometrics: []
    };
  }
  componentDidMount = () => {};


  handleLoader = e => {
    this.setState({ isAPICalled: e });
  };

  /** set values for request details */
  setRequestDetails = (val, biometrics = []) => {
    this.setState({
      textRequestedId: val?.RequestId,
      visitorData: val,
      enableBRR: val?.IsSignedDocument ? false : true,
      isBRRCompleted: val?.IsSignedDocument,
      isSignedDocument: (val?.IsSignedDocument === 1 || val?.IsSignedDocument === true) ? true : false,
      showSuccessIcon: false,
      biometrics
    });
  };

  /** clear storage */
  clearStorage = () => {
    localStorage.removeItem("valueOfRequestId");
    localStorage.removeItem("textRequestedId");
    localStorage.removeItem("textEmailAddress");
  };

  render() {
    const {
      isAPICalled,
      enableBRR,
      textRequestedId,
      isSignedDocument,
      visitorData,
      isBRRCompleted,
      uploadDoc,
      showSuccessIcon,
      biometrics
    } = this.state;

    const isBiometricDocumentAlreadySigned = biometrics.find(x=> x.isBiometricDocumentAlreadySigned == false && x.requireBiometrics== true) !== undefined;
    return (
      <>
        <div className={"col-xs-12 abrf-request-container"}>
          <ToastMessage />
          <FullPageLoader requestCount={isAPICalled ? 1 : 0} />
          <div className={"row"}>
            <div className={"col-xs-12"}>
              <h2>{"Welcome To Stream Data Center!"}</h2>
            </div>
          </div>

          <div>
            <Accordion defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={"panel1a-content"}
                id={"searchSection"}
              >
                <Typography className={"accordion-header"}>
                  {"Search Request\r"}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                style={{ display: "grid" }}
                className={"div-border"}
              >
                <Typography>
                  <SearchRequest
                    handleLoader={this.handleLoader}
                    setRequestDetails={this.setRequestDetails}
                  />
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion disabled={textRequestedId && enableBRR ? false : true}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={"panel1a-content"}
                id={"brrSection"}
              >
                <Typography className={"accordion-header"}>
                  {isSignedDocument ? "BRR (Already Signed)" : "BRR"}
                </Typography>
                {showSuccessIcon && (
                  <CheckCircleOutlineIcon
                    style={{ fill: "green", paddingBottom: "6px" }}
                  />
                )}
              </AccordionSummary>
              {textRequestedId && enableBRR && (
                <AccordionDetails
                  style={{ display: "grid" }}
                  className={"div-border"}
                >
                  <Typography>
                    <BrrRequest
                      visitorData={visitorData}
                      handleLoader={this.handleLoader}
                      uploadDoc={uploadDoc}                      
                      setRequestDetails={this.setRequestDetails}
                      biometrics={biometrics}
                    />
                  </Typography>
                </AccordionDetails>
              )}
            </Accordion>

            { biometrics?.find(x => x.requireBiometrics === true) !== undefined ? 
              <Accordion
                disabled={
                  (isBRRCompleted == 1 || isBRRCompleted == true) && isBiometricDocumentAlreadySigned
                    ? false
                    : true
                }
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={"panel1a-content"}
                  id={"biometricSection"}
                >
                  <Typography className={"accordion-header"}>
                    {(isBRRCompleted == 1 || isBRRCompleted == true) && !isBiometricDocumentAlreadySigned ? "Biometric (Already Signed)" : "Biometric\r"}
                  </Typography>
                </AccordionSummary>
                {textRequestedId && (isBRRCompleted == 1 || isBRRCompleted == true) && (
                  <AccordionDetails
                    style={{ display: "grid" }}
                    className={"div-border"}
                  >
                    <Typography>
                      <BiometricRequest
                        visitorData={visitorData}
                        textRequestedId={textRequestedId}
                        handleLoader={this.handleLoader}                                            
                        setRequestDetails={this.setRequestDetails}
                        biometrics={biometrics}
                      />
                    </Typography>
                  </AccordionDetails>
                )}
              </Accordion>
            : ""}
          </div>
        </div>
      </>
    );
  }
}
